import { Component, OnInit } from '@angular/core';
import { ProizvodiService } from './sifarnik-proizvodi.service';
import notify from 'devextreme/ui/notify';
import { moduli } from '../../config';

@Component({
  selector: 'app-sifarnik-proizvodi',
  templateUrl: './sifarnik-proizvodi.component.html',
  styleUrls: ['./sifarnik-proizvodi.component.scss'],
  providers: [ProizvodiService]
})

export class SifarnikProizvodiComponent implements OnInit {

  idkorisnik: any = localStorage.getItem('idsecuser');
  access_token: any = sessionStorage.getItem('token');
  idfirma: any = localStorage.getItem('firma');

  proizvodi: any = [];
  noDataMessage = 'Učitavanje...';

  naslov: string = 'Popis barkodova';
  barkodovi: any = [];
  bkPopup: boolean = false;

  vrsta: number = 1;
  vrstaArray: any = [
    {idvrsta: 1, vrsta_naziv: 'PROIZVOD', vrsta_vrijednost: 1},
    {idvrsta: 2, vrsta_naziv: 'SIROVINA', vrsta_vrijednost: 2},
    {idvrsta: 3, vrsta_naziv: 'SVE', vrsta_vrijednost: 'all'}
  ];
  aktivan: number = 1;
  statusArray: any = [
    {idstatus: 1, status_naziv: 'AKTIVNI', status_vrijednost: 1},
    {idstatus: 2, status_naziv: 'NEAKTIVNI', status_vrijednost: 0},
    {idstatus: 3, status_naziv: 'SVI', status_vrijednost: 'all'}
  ];

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private _proizvodiService: ProizvodiService) {


    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().sifarnikProizvodi;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  onToolbarPreparing(e: any){
    //console.log(e);
    e.toolbarOptions.items.unshift(
    /*
    {
      location: 'before',
      template: 'naslovPregleda',    
    },
    */
    {
      location: 'before',
      template: 'odabirVrste',
    },
    {
      location: 'before',
      template: 'odabirStatusa',
    })
  }

  vrstaOdabrana(data: any){
    //console.log(data);
    //console.log(data.value);
    this.vrsta = data.value;
    this.dohvatiProizvode();
  }


  statusOdabran(data: any){
    //console.log(data);
    //console.log(data.value);
    this.aktivan = data.value;
    this.dohvatiProizvode();
  }

  dohvatiProizvode() {
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      access_token: this.access_token,
      idfirma: this.idfirma,
      vrsta: this.vrsta,
      ar_aktivan: this.aktivan
    }
    //console.log(podaciZaSlanje);
    this._proizvodiService.dohvatiSveProizvode(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      this.proizvodi = [];
      if (res.success === true) {
        for (let data of res.data) {
          let arr = { ...data, aktivan: data.ar_aktivan ? 'Aktivan' : 'Neaktivan', };
          this.proizvodi.push(arr);
        }
        //console.log(this.proizvodi);
      }
    });
  }

  artiklUredi(e) {
    //console.log(e.data);
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      access_token: this.access_token,
      idfirma: this.idfirma,
      idartikl: e.data.ar_id,
      ar_alarm_dani_rok: e.data.ar_alarm_dani_rok,
      ar_alarm_dani_dobavljivost: e.data.ar_alarm_dani_dobavljivost,
      ar_aktivan: e.data.aktivan === 'Aktivan' ? 1 : 0
    };
    //console.log(podaciZaSlanje);
    this._proizvodiService.artiklUredi(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.dohvatiProizvode();
        notify("Artikl je uspješno uređen!", "success", 3000);
      } else {
        this.dohvatiProizvode();
        notify("Došlo je do pogreške, pokušajte ponovno!", "warning", 3000);
      }
    });
  }

  dohvatiArtikl_barkod(e){
    //console.log(e.data);
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      access_token: this.access_token,
      idfirma: this.idfirma,
      idartikl: e.data.ar_id
    }
    //console.log(podaciZaSlanje)
    this._proizvodiService.barkodPopis(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      this.barkodovi = [];
      if (res.success === true) {
        let brojac = 1;
        for (let data of res.data) {
          let arr = { ...data, redni_broj: brojac++ };
          this.barkodovi.push(arr);
        }
        //console.log(this.barkodovi);
      }
      this.bkPopup = true;
    });
  }

  urediBarkod(e, data){
    //console.log(e);
    //console.log(data.data);
    let za_narudzbu = 0;
    if (e.value === true) {
      za_narudzbu = 1;
    }else{
      za_narudzbu = 0;
    }
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      access_token: this.access_token,
      idfirma: this.idfirma,
      bk_id: data.data.bk_id,
      bk_kod: data.data.bk_kod,
      bk_zanarudzbu: za_narudzbu
    }
    //console.log(podaciZaSlanje);
    this._proizvodiService.barkodUredi(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        notify("Barkod je uspješno uređen!", "success", 3000);
      }else{ 
        notify("Došlo je do pogreške, pokušajte ponovno!", "warning", 3000);
      }
    });
  }
  

  ngOnInit(): void {
    this.dohvatiProizvode();
  }

}
